import { onError } from '@apollo/client/link/error';
import { faro } from '@grafana/faro-web-sdk';

const UNAUTHORISED_STATUS_CODE = 401;
// The data-export operations are excluded because a hard redirect to /login would
// permanently lose the token from /data-export/:token; the page renders its own sign-in state.
const REDIRECT_EXCLUDE_OPERATIONS = ['validateToken', 'AppConfig', 'dataExport', 'dataExportArtifactDownloadUrl'];

// this doesn't allow us to remember the error page and get back to where we were
const redirectToLoginPage = () => window.location.replace(`${window.document.baseURI}login`);

const isRedirectError = ({ message, operation, status }) => {
  if (REDIRECT_EXCLUDE_OPERATIONS.includes(operation.operationName)) {
    return false;
  }
  const messageLower = message?.toLowerCase();
  return (
    status === UNAUTHORISED_STATUS_CODE ||
    messageLower.includes('401 unauthorized') ||
    messageLower.includes('401: unauthorized')
  );
};

function shouldRedirectToLogin({ graphQLErrors, operation }) {
  return graphQLErrors?.some(({ message, extensions: { response: { status } = {} } = {} }) =>
    isRedirectError({ message, operation, status }),
  );
}

function redirectIfNeeded(error) {
  if (shouldRedirectToLogin(error)) {
    faro?.api?.pushError(error, {
      type: 'apolloError',
      context: {
        message: error.graphQLErrors[0].message,
        operationName: error.operation.operationName,
        result: 'RedirectToLogin',
      },
    });
    redirectToLoginPage();
  }
}

export default onError(redirectIfNeeded);
